export default __webpack_public_path__ + "static/media/DSC_8092.061ce5f6.jpg";